import lost from "./lost.component";
import lostUrls from "./lost.urls";
import LostTransforms from "./lost.transforms";

const lostModule = angular
  .module("app.components.lost", [])
  .component("lostPage", lost)
  .service("LostTransforms", LostTransforms)
  .config(lostUrls);

export default lostModule;



// WEBPACK FOOTER //
// ./src/pages/lost/lost.module.js